import client from './client';

export const customersApi = {
  async getCustomers(params = {}) {
    const { data } = await client.get('/api/customers', { params });
    return data;
  },

  async createCustomer(customerData) {
    const { data } = await client.post('/api/customers', customerData);
    return data;
  },

  async getCustomer(id) {
    const { data } = await client.get(`/api/customers/${id}`);
    return data;
  },

  async updateCustomer(id, customerData) {
    const { data } = await client.patch(`/api/customers/${id}`, customerData);
    return data;
  },

  async archiveCustomer(id) {
    const { data } = await client.delete(`/api/customers/${id}`);
    return data;
  },

  async addHelpdeskLink(id, helpdeskApp) {
    const { data } = await client.post(`/api/customers/${id}/helpdesk-links`, { helpdeskApp });
    return data;
  },

  async rotateHelpdeskKey(id, linkId) {
    const { data } = await client.post(`/api/customers/${id}/helpdesk-links/${linkId}/rotate`);
    return data;
  },

  async removeHelpdeskLink(id, linkId) {
    const { data } = await client.delete(`/api/customers/${id}/helpdesk-links/${linkId}`);
    return data;
  },

  async addNote(id, text, createdAt) {
    const payload = { text };
    if (createdAt) payload.createdAt = createdAt;
    const { data } = await client.post(`/api/customers/${id}/notes`, payload);
    return data;
  },

  async updateNote(id, noteId, text) {
    const { data } = await client.patch(`/api/customers/${id}/notes/${noteId}`, { text });
    return data;
  },

  async getUsers(id) {
    const { data } = await client.get(`/api/customers/${id}/users`);
    return data;
  },

  async linkXeroContact(id, xeroContactId, xeroContactName) {
    const { data } = await client.post(`/api/customers/${id}/xero-link`, {
      xeroContactId,
      xeroContactName,
    });
    return data;
  },

  async unlinkXeroContact(id) {
    const { data } = await client.delete(`/api/customers/${id}/xero-link`);
    return data;
  },

  async addContact(customerId, contactData) {
    const { data } = await client.post(`/api/customers/${customerId}/contacts`, contactData);
    return data;
  },

  async updateContact(customerId, contactId, contactData) {
    const { data } = await client.patch(
      `/api/customers/${customerId}/contacts/${contactId}`,
      contactData
    );
    return data;
  },

  async deleteContact(customerId, contactId) {
    const { data } = await client.delete(`/api/customers/${customerId}/contacts/${contactId}`);
    return data;
  },

  async uploadAttachment(id, file) {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await client.post(`/api/customers/${id}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  async deleteAttachment(id, attachmentId) {
    const { data } = await client.delete(`/api/customers/${id}/attachments/${attachmentId}`);
    return data;
  },

  async addDocumentLink(id, { title, url }) {
    const { data } = await client.post(`/api/customers/${id}/document-links`, { title, url });
    return data;
  },

  async deleteDocumentLink(id, linkId) {
    const { data } = await client.delete(`/api/customers/${id}/document-links/${linkId}`);
    return data;
  },

  async getBroadcasts(id) {
    const { data } = await client.get(`/api/customers/${id}/broadcasts`);
    return data;
  },
};
